'use strict';

module.exports = () => {
    return (next) => {
        return (action) => {
            return next(action);
        };
    };
};



// WEBPACK FOOTER //
// ./client/src/middleware/console-middleware.js